import { render, staticRenderFns } from "./EditBoardMemberPage.vue?vue&type=template&id=8a38320e&scoped=true&"
import script from "./EditBoardMemberPage.vue?vue&type=script&lang=js&"
export * from "./EditBoardMemberPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a38320e",
  null
  
)

export default component.exports